import React from "react";
import img from "../../../../assets/images/Landing/images/Web-developer.svg";
import { Link } from "react-router-dom";
import styles from "./Intro.module.css";

const Intro = () => {
  return (
    <>
      <div className={styles.container} id="about">
        <div className={styles.row} data-aos="fade-up">
          <div className={styles.imgContainer}>
            <img alt="card img" className={styles.img} src={img} />
          </div>
          <div
            className={styles.textContainer}
            data-aos="zoom-in"
            data-aos-delay="500"
          >
            <h3 className={styles.heading}>
              Boost Your Success with PRO AI Realtor Assistance
            </h3>
            <div>
              <p className={styles.paragraph}>
                Gain access to predictive insights, client data analytics, and
                automation features to streamline your workflow and make
                smarter, faster decisions. Seamlessly manage property listings,
                engage clients through high-impact visuals, create blogs/reels,
                and enhance your business with our integrated tools.
              </p>
            </div>
            <div>
              <p className={styles.paragraph}>
                Leverage our cutting-edge AI solutions to stay ahead of market
                trends, attract more clients, and close deals faster than ever
                before.
              </p>
            </div>
            <Link to="/contact" className={styles.button}>
              Contact us
              <svg
                className={`${styles.icon} group-hover:${styles.iconHover}`}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Intro;
